module.exports = __webpack_public_path__ + "static/img/building.264d32d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/building.png
// module id = guhP
// module chunks = 192